const blackList = ["de"];

const getInitialsName = fullName =>
  fullName
    .replace(/[^\w\s]/gi, "")
    .split(" ")
    .filter(item => !blackList.includes(item.toLowerCase()))
    .slice(0, 3)
    .reduce((acc, part) => `${acc}${part[0]}`, "")
    .trim()
    .toUpperCase();

export default getInitialsName;
